@if ((showPendingChangeBanner$ | async) === true) {
<nb-alert outline="warning">
  <div class="d-flex justify-content-between">
    <span translate="auth.pendingPermissionUpdate" class="my-auto"></span>
    <button
      nbButton
      (click)="reload()"
      status="primary"
      class="float-right"
      size="small"
    >
      <nb-icon icon="refresh-outline"></nb-icon>
      <span translate="build.reload"></span>
    </button>
  </div>
</nb-alert>
}
